import IBModuleApi from "../../api/iuviBankingAPI";
import { urlContexts } from "../../constants";

export const getApplications = async (appId?: any, tenantId?: string) => {
  const { data } = await IBModuleApi.get(
    `${process.env.REACT_APP_BACKEND_HOST}/${urlContexts.console}/rest/1.0/cs/application${appId ? `/${appId}` : ""
    }`,
    {
      params: {
        tenantid: tenantId,
      }
    }
  );

  return data;
};

export const createApplications = async (createInfo: any) => {
  const { data } = await IBModuleApi.post(
    `${process.env.REACT_APP_BACKEND_HOST}/${urlContexts.console}/rest/1.0/cs/application`,
    createInfo
  );

  return data;
};

export const updateApplications = async (updateInfo: any) => {
  const { data } = await IBModuleApi.put(
    `${process.env.REACT_APP_BACKEND_HOST}/${urlContexts.console}/rest/1.0/cs/application`,
    updateInfo
  );

  return data;
};

export const deleteApplication = async (appId: string) => {
  const { data } = await IBModuleApi.delete(
    `${process.env.REACT_APP_BACKEND_HOST}/${urlContexts.console}/rest/1.0/cs/application/${appId}`
  );

  return data;
};

export const getApplicationByTenant = async (tenantId?: any) => {
  const { data } = await IBModuleApi.get(
    `${process.env.REACT_APP_BACKEND_HOST}/${urlContexts.console}/rest/1.0/cs/applications`,
    {
      params: {
        tenantid: tenantId,
      }
    }
  );

  return data;
};
